import React from 'react';

import Spinner from '@/components/common/Spinner/Spinner';
import Logo from '@/assets/img/access-logo.svg?react';
import styles from './initial-spinner.module.scss';

export default function InitialSpinner() {
  return (
    <div className={styles.overlay}>
      <div className={styles.wrapper}>
        <div className={styles['logo-wrapper']}>
          <Logo />
        </div>

        <Spinner />
      </div>
    </div>
  );
}
